import FormGroup from "features/shared/forms/components/FormGroup";
import React from "react";
import Select from "react-select";
import reactSelectStyles from 'features/shared/components/reactSelect/reactselectcustom.module.scss';
import { Nullable } from "features/shared/types/nullable";
import AddAccountButton from 'features/requirements/components/paymentMethodForm/AddAccountButton';
import CustomerSipoAccountDTO from "features/customer/dtos/CustomerSipoAccountDTO";
import { isEmpty } from "features/shared/helpers/objects";
import { useTranslation } from "react-i18next";

interface Props {
  name: string;
  sipos: CustomerSipoAccountDTO[];
  onChange: (sipo: Nullable<CustomerSipoAccountDTO>) => void;
  selectedSipo?: Nullable<CustomerSipoAccountDTO>;
  onSipoAccountAddClick: (paymentCategory?: string) => void;
  errors: Record<string, string>;
  paymentCategory?: string;
}

const SipoSelect = ({ name, sipos, onChange, selectedSipo, onSipoAccountAddClick, errors, paymentCategory }: Props) => {
  // translations
  const tLabels = useTranslation("requirements\\requirements").t;

  // render
  return (
    <FormGroup 
      labelText={tLabels("sipoSelect.sipo")}
      validationError={errors ? errors[name] : undefined}
    >
      <div className="row no-gutters">
        <div className="col">
          <Select
            options={sipos}
            getOptionLabel={(sipo) => sipo.sipoNumber!}
            getOptionValue={(sipo) => sipo.sipoNumber!}
            value={!isEmpty(selectedSipo!) ? selectedSipo : undefined}
            onChange={onChange}
            isSearchable={false}
            captureMenuScroll={false}
            className={reactSelectStyles.customSelect}
            classNamePrefix="customSelect"
            placeholder={tLabels("sipoSelect.setSipo")}
            noOptionsMessage={() => tLabels("sipoSelect.noSipoAccounts")}
          />
        </div>
        <div className="col-auto pl-2">
          <AddAccountButton onClick={() => onSipoAccountAddClick(paymentCategory)} />
        </div>
      </div>
    </FormGroup>
  )
}

export default SipoSelect;
